/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "../templates/template1/themes/default/css/ticket.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./product-tickets.component";
import * as i3 from "../../shared/services/data.service";
import * as i4 from "../../shared/services/common.service";
var styles_ProductTicketsComponent = [i0.styles];
var RenderType_ProductTicketsComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ProductTicketsComponent, data: {} });
export { RenderType_ProductTicketsComponent as RenderType_ProductTicketsComponent };
export function View_ProductTicketsComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_ProductTicketsComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "product-tickets", [], null, null, null, View_ProductTicketsComponent_0, RenderType_ProductTicketsComponent)), i1.ɵdid(1, 114688, null, 0, i2.ProductTicketsComponent, [i3.DataShareService, i4.CommonService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ProductTicketsComponentNgFactory = i1.ɵccf("product-tickets", i2.ProductTicketsComponent, View_ProductTicketsComponent_Host_0, {}, {}, []);
export { ProductTicketsComponentNgFactory as ProductTicketsComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/product-tickets.component.ngfactory.js.pre-build-optimizer.js